<main>
    <section class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-3">
        <div>
            <h1 class="text-2xl font-bold text-gray-800">Convertir albaranes a presupuesto</h1>
            <p class="text-sm text-gray-500 mt-1">
                Solo se muestran los albaranes que no tienen relación con ningún otro documento (no facturados
                ni generados a partir de un presupuesto).
            </p>
        </div>

        <div class="flex items-center gap-3">
            <span class="text-sm font-medium text-gray-600">{{ selectedCount }} seleccionado(s)</span>
            <button type="button" [disabled]="!selectedCount" (click)="clearSelection()"
                class="cursor-pointer px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
                Deseleccionar todo
            </button>
            <button type="button" [disabled]="!selectedCount || converting" (click)="convertSelected()"
                class="cursor-pointer px-4 py-2 text-sm font-semibold text-white bg-emerald-600 rounded-lg hover:bg-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed">
                {{ converting ? 'Convirtiendo...' : 'Convertir a presupuesto' }}
            </button>
        </div>
    </section>

    <ng-template #selectTmpl let-item="item">
        <input type="checkbox" [checked]="isSelected(item.id)" (change)="toggleSelect(item.id)"
            class="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 cursor-pointer">
    </ng-template>

    <ng-template #totalTmpl let-item="item">
        <span class="font-semibold text-sm text-gray-900" [centToEurDisplay]="item.total"></span>
    </ng-template>

    <div class="flex items-center gap-2 mb-2">
        <input type="checkbox" [checked]="allVisibleSelected" (change)="toggleSelectAllVisible()"
            [disabled]="!currentPageItems.length"
            class="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 cursor-pointer">
        <span class="text-xs text-gray-500">Seleccionar todos los visibles en esta página</span>
    </div>

    <sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" contentTotal="total"
        pageParamName="page" limitParamName="limit" [headers]="headers" [showOptions]="true"
        [customTemplates]="{ 'select': selectTmpl, 'total': totalTmpl }" [limit]="10"
        (itemsLoadedEvent)="onItemsLoaded($event)">
    </sau-table>
</main>
